import { render } from "./HomeLatestNotice.vue?vue&type=template&id=e7026d8c&ts=true"
import script from "./HomeLatestNotice.vue?vue&type=script&lang=ts"
export * from "./HomeLatestNotice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__